import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "organization-service/api/cms/";
const BASE_SERVICE_URL_v1 = "organization-service/v1/cms/";

export default {
  getBrandsBranches: function(param) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}brands-branches/page/${param.page}`,
        param.payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getDeliverySettings: function() {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}fulfillment/delivery-settings`,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  saveDeliverySettings: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}fulfillment/delivery/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        })
    });
  },
  getPickupSettings: function() {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}fulfillment/pickup-settings`,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  savePickupSettings: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}fulfillment/pickup/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        })
    });
  },
  getPreOrderingSchedule: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}pre-order-schedule/settings`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  savePreOrderingSchedule: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}pre-order-schedule/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getFulfillmentFeesSettings: function() {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}fulfillment-fees-settings`,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  saveFulfillmentFeesSettings: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}fulfillment-fees-settings/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getFulfillmentSettings: function() {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}fulfillment-settings`,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  saveFulfillmentSettings: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL}fulfillment-settings/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  saveDineInFeeSettings: function(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${BASE_SERVICE_URL_v1}table-ordering/dine-in/settings/save`,
        payload,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
